import React, { Component } from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import axios from 'axios';
// import { Link } from 'react-router-dom';

import EnlisteeSearchResults from './EnlisteeSearchResults';

import { apiBase } from '../data/api';

const KEYS_TO_FILTERS = [ 'node.title' ];

class EnlisteeSearchForm extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      searchTerm: '',
      data: { nodes: [], pager: {} },
      dataError: false,
      loading: false,
    };
  }

  fetchResults = ( term ) => {
    let self = this;
    axios( {
      method: 'get',
      url: `${apiBase}/plaques/enlistees.json?title=${term}`,
    } ).then( function ( response ) {
      self.setState( {
        data: response.data,
        dataError: false,
        loading: false,
      } );
      console.log( response );
    } )
    .catch( function ( error ) {
      self.setState( {
        dataError: true,
        loading: false,
      } );
    } );
  };

  searchUpdated = ( term ) => {
    this.setState( {
      searchTerm: term,
      loading: true,
    } );
    this.fetchResults( term );
  };

  render() {
    const results = this.state.data.nodes.filter( createFilter( this.state.searchTerm, KEYS_TO_FILTERS ) );
    return (
      <div className="EnlisteeSearchForm">
        <SearchInput className="search-input" throttle={500} onChange={this.searchUpdated} placeholder="Search enlistees"/>
        <EnlisteeSearchResults
          results={results}
          pagination={this.state.data.pager}
          error={this.state.dataError}
          loading={this.state.loading}
          term={this.state.searchTerm}/>
      </div>
    )
  }
}

export default EnlisteeSearchForm;
